import { createContext } from 'react';
import { Answer, Question } from '~/types';

export type SubmitAnswerFunction = (jumpQuestionId: number | null) => void;

export interface QuestionContextType {
    question: Question & { answers: Array<Answer> };
    onSubmitAnswer: SubmitAnswerFunction;
    questionTime: number;
    ratingId: number | null;
}

export const QuestionContext = createContext<QuestionContextType | null>(null);